import http from "../../axiosSetup";

class BulkUploadService {
  static bulkCreate(newAthletes) {
    return http.post("/athlete-upload/save", newAthletes).then((response) => response.data);
  }
}
export default BulkUploadService;
